import { useEffect, useState } from "react";
import { api, formatBRL } from "../../lib/api";
import { Plus, Building2, MapPin, Trash2, Star } from "lucide-react";
import { toast } from "sonner";

const empty = { name: "", city: "", state: "", address: "", active: true };

export default function Unidades() {
  const [items, setItems] = useState([]);
  const [consolidated, setConsolidated] = useState([]);
  const [form, setForm] = useState(empty);
  const [showForm, setShowForm] = useState(false);

  const load = () => Promise.all([
    api.get("/units/").then(r => setItems(r.data)),
    api.get("/units/consolidated").then(r => setConsolidated(r.data)).catch(() => {}),
  ]);
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.post("/units/", form);
      toast.success("Unidade criada");
      setForm(empty); setShowForm(false);
      load();
    } catch { toast.error("Erro ao criar"); }
  };

  const remove = async (id) => {
    if (!confirm("Remover unidade?")) return;
    try { await api.delete(`/units/${id}`); toast.success("Removida"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Erro"); }
  };

  return (
    <div data-testid="admin-unidades">
      <div className="admin-page-header">
        <div>
          <div className="text-xs uppercase tracking-[0.18em] text-[#D4AF37] font-semibold mb-2">SaaS · Multiunidades</div>
          <h1 className="font-display text-2xl sm:text-3xl text-[#14213D] font-light">Unidades</h1>
        </div>
        <button onClick={() => setShowForm(!showForm)} className="w-full sm:w-auto bg-[#14213D] text-white px-5 py-2.5 rounded-md text-sm font-semibold inline-flex items-center justify-center gap-2" data-testid="new-unit-btn">
          <Plus size={16} /> Nova Unidade
        </button>
      </div>

      {showForm && (
        <form onSubmit={save} className="bg-white border border-gray-200 rounded-lg p-6 mb-6 grid grid-cols-1 md:grid-cols-3 gap-3" data-testid="unit-form">
          <input required placeholder="Nome da unidade *" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="border border-gray-200 rounded px-3 py-2 text-sm md:col-span-2" />
          <input required placeholder="Cidade *" value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} className="border border-gray-200 rounded px-3 py-2 text-sm" />
          <input required maxLength={2} placeholder="UF *" value={form.state} onChange={(e) => setForm({ ...form, state: e.target.value.toUpperCase() })} className="border border-gray-200 rounded px-3 py-2 text-sm" />
          <input placeholder="Endereço completo" value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} className="border border-gray-200 rounded px-3 py-2 text-sm md:col-span-2" />
          <button type="submit" className="md:col-span-3 bg-[#D4AF37] text-[#14213D] font-semibold py-2.5 rounded text-sm" data-testid="save-unit">Criar unidade</button>
        </form>
      )}

      <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6 text-xs text-amber-900">
        <strong>Multiunidades:</strong> a arquitetura suporta múltiplas unidades. Recursos podem ser vinculados via <code className="bg-amber-100 px-1 rounded">unit_id</code>. Consolidação automática nos KPIs abaixo.
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((u) => {
          const c = consolidated.find(x => x.id === u.id) || {};
          return (
            <div key={u.id} className="bg-white border border-gray-200 rounded-lg p-5 hover:border-[#D4AF37] transition" data-testid={`unit-${u.id}`}>
              <div className="flex items-start justify-between mb-2">
                <div className="w-10 h-10 rounded-md bg-[#14213D] text-[#D4AF37] flex items-center justify-center"><Building2 size={18} /></div>
                {u.default && <Star size={14} className="text-[#D4AF37]" fill="currentColor" />}
              </div>
              <div className="font-display text-lg text-[#14213D]">{u.name}</div>
              <div className="text-xs text-gray-500 flex items-center gap-1 mb-3"><MapPin size={11} />{u.city}/{u.state}</div>
              <div className="grid grid-cols-3 gap-2 pt-3 border-t border-gray-100">
                <div><div className="text-[10px] uppercase tracking-wider text-gray-400 font-semibold">MRR</div><div className="text-sm font-semibold text-[#14213D]">{formatBRL(c.mrr || 0)}</div></div>
                <div><div className="text-[10px] uppercase tracking-wider text-gray-400 font-semibold">Clientes</div><div className="text-sm font-semibold text-[#14213D]">{c.clients ?? 0}</div></div>
                <div><div className="text-[10px] uppercase tracking-wider text-gray-400 font-semibold">Espaços</div><div className="text-sm font-semibold text-[#14213D]">{c.spaces ?? 0}</div></div>
              </div>
              {!u.default && (
                <button onClick={() => remove(u.id)} className="mt-3 w-full border border-red-200 text-red-600 rounded py-1.5 text-xs flex items-center justify-center gap-1 hover:bg-red-50" data-testid={`del-unit-${u.id}`}>
                  <Trash2 size={12} /> Remover
                </button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
